import React from 'react'


export const IndeterminateProgressBar = () => (
  <div className="dot-elastic"></div>
)